import React from 'react';
import { IResource } from '~/redux';

import RenderPDF from '../parts/RenderPDF';
import RenderVideo from '../parts/RenderVideo';
import config from '~/config';
import { ResourcesItemActions } from '../layout/resources/ResourcesItemCommon';
import { ModalContainer, ModalBody, ModalFooter } from './ResourceModalCommon';
import LeavingPromptModal from './LeavingPromptModal';

interface Props {
  config: IResource
}
const ResourceOutputModal: React.FC<Props> = (props) => {
  const resource = props.config;


  if( resource.type === 'Link' ) {
    return <LeavingPromptModal link={resource.resource_link} title={resource.title} />
  }

  return (
    <ModalContainer className={`resource-modal-type--${resource.type}`}>
      <ModalBody>

        {
          ( resource.type === 'Document' || resource.type === 'Presentation' ) && (
            <RenderPDF
              file={config.strapiAPI.URL + resource.resource_asset[0].url}
              config={resource}
            />
          )
        }

        {resource.type === 'Video' && (
          <RenderVideo
            file={config.strapiAPI.URL + resource.resource_asset[0].url}
            config={resource}
          />
        )}

        {resource.type === 'Image' && (
          <img
            src={config.strapiAPI.URL + resource.resource_asset[0].url}
            alt={resource.title}
          />
        )}

      </ModalBody>
      <ModalFooter>
        <div className='footer-container-left'>
          <div className='resource-title' dangerouslySetInnerHTML={{ __html: resource.title }}/>
          <div className='resource-description' dangerouslySetInnerHTML={{ __html: resource.description}}/>
        </div>
        <div className='footer-container-right'>
          <ResourcesItemActions resource={resource} />
        </div>
      </ModalFooter>
    </ModalContainer>
  );
}

export default ResourceOutputModal;



// WEBPACK FOOTER //
// ./src/components/modals/ResourceOutputModal.tsx